import React from "react";
import { TokenProvider } from "src/components/authentication/TokenProvider";
import { AppContent } from "./AppContent";

function ServiceProvider() {
  return (
    <TokenProvider>
      <AppContent />
    </TokenProvider>
  );
}

export default ServiceProvider;
